import { VariantResponse } from '../../types/VariantResponse';

const BASE_URL = process.env.API_BASE_URL;
const PATH = '/cmm-cim/v1/variants/settings/';

export const getVariant = (id: string): Promise<VariantResponse> => {
  return fetch(`${BASE_URL}${PATH}${id}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
  })
    .then((response) => response.json())
    .then((response) => response)
    .catch((error) => {
      throw new Error(error);
    });
};
